import React from 'react';
import { useSelector } from 'react-redux';
import Dashboard from '../modulos/dashboard/Dashboard';
import AdministradorList from '../modulos/administrador/AdministradorList';
import PropiedadList from '../modulos/propiedad/PropiedadList';
import ConjuntoList from '../modulos/conjunto/ConjuntoList';
import ProveedorList from '../modulos/proveedor/ProveedorList';
import PersonaList from '../modulos/persona/PersonaList';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import RolList from '../modulos/rol/RolList';
import UsuarioList from '../modulos/usuario/UsuarioList';
import Tipo_identificacionList from '../modulos/tipo_identificacion/Tipo_identificacionList';
import Tipo_personaList from '../modulos/tipo_persona/Tipo_personaList';
import Tipo_propiedadList from '../modulos/tipo_propiedad/Tipo_propiedadList';
import Tipo_proveedorList from '../modulos/tipo_proveedor/Tipo_proveedorList';
import PagoList from '../modulos/pago/PagoList';
import Tipo_estadoList from '../modulos/tipo_estado/Tipo_estadoList';
import Tipo_categoriaList from '../modulos/tipo_categoria/Tipo_categoriaList';
import TareaList from '../modulos/tarea/TareaList';
import ComunicadoList from '../modulos/comunicado/ComunicadoList';
import ComunicacionList from '../modulos/comunicacion/ComunicacionList';
import ComunicacionHistorico from '../modulos/comunicacion/ComunicacionHistorico';
import Resolucion_facturacionList from '../modulos/resolucion_facturacion/Resolucion_facturacionList';


function Container(props) {

    const currentMenuAction = useSelector(state => state.common.currentMenuAction);
    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const { t } = useTranslation();

    const selMenu = logguedUserData?.menu?.find(m => m.nombre === currentMenuAction);

    if (selMenu) {
        const permissions = logguedUserData?.permissions?.find(p => p.modulo_id === selMenu?.id && p.conjunto_id === logguedUserData?.selConjunto?.id);
        if (!logguedUserData?.isAdmin && !permissions) {
            toast(t("NO_PERMISOS"));
            return (<Dashboard />);
        }
    }

    switch (currentMenuAction) {
        case 'dashBoard':
        case 'DashBoard':
            return <Dashboard />;
        case 'administrador':
            return <AdministradorList />;
        case 'propiedad':
            return <PropiedadList />
        case 'conjunto':
            return <ConjuntoList />
        case 'proveedor':
            return <ProveedorList />
        case 'persona':
            return <PersonaList />
        case 'rol':
            return <RolList />
        case 'usuario':
            return <UsuarioList />
        case 'tipo_identificacion':
            return <Tipo_identificacionList />
        case 'tipo_persona':
            return <Tipo_personaList />
        case 'tipo_propiedad':
            return <Tipo_propiedadList />
        case 'tipo_proveedor':
            return <Tipo_proveedorList />
        case 'tipo_estado':
            return <Tipo_estadoList />
        case 'tipo_categoria':
            return <Tipo_categoriaList />
        case 'pago':
            return <PagoList />
        case 'tarea':
            return <TareaList />
        case 'comunicado':
            return <ComunicadoList />
        case 'comunicacion':
            if (!logguedUserData?.isAdmin) {
                return <ComunicacionList />
            } else {
                return <ComunicacionHistorico />
            }

        case 'resolucion_facturacion':
            return <Resolucion_facturacionList />
        default:
            //if (currentMenuAction) toast(t("MODULO_NO_ENCONTRADO"));
            return (<Dashboard />);
    }
}

export default Container;